<template>
  <div class="safeContent">
    <headerPage></headerPage>
    <!-- 头部内容 -->
    <!-- <div  style="margin-top:5px" class="headerContent">
      <div class="block">
          <el-carousel height="570px" width="100%" >
            <el-carousel-item  v-for="(item,index)  in indexBanner" :key="index">
              <img  :src="item.src" alt="">
            </el-carousel-item>
          </el-carousel>
      </div>
    </div> -->
    <img style="width:100%;margin-top:5px;" :src="indexBanner[0].src" alt="沁恒数联云盒">
    <!-- 系统简介 -->
    <div class="sysIntro">
      <div style="width:100%;position:relative">
              <img  style="position:absolute;left:0;z-index:-1" src="@/assets/img/service_jgbackground.png" alt="">
              <div class="sys_center"  >
                    <div style="margin-top:100px;width:580px;">
                         <div >系统介绍</div>
                         <div style="font-size:14px;margin-top:33px;line-height:32px;">
                          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;随着新零售时代的全面到来，泛零售行业对线下消费数据整合、应用的需求日益增长。由此，致力于快速可靠地汇集线下消费信息、精准高效地进行大数据转化、稳健有力地赋能后续商业活动，首创采用“芯 + 云”服务模式的第四代沁恒线下打印数据无感归集系统应运而生。</p>
                          <p style="padding-top:10px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;沁恒第四代线下打印数据无感归集系统由线上数联慧通平台与线下数联云盒构成。将打印的小票数据实时汇集到云端，并进行图片还原、OCR识别、关键词提取等操作，精准输出小票明细内容。</p>                          
                          <div style="margin-top:50px;text-align:right">
                             <a style="color:white;font-size:16px;" href="https://ipdcloud.wch.cn/manage/login#/login" target="_blank">快速体验>></a>
                             <!-- <router-link  to="/service" ><img src="@/assets/img/btn.png" alt=""> </router-link>  -->
                          </div>
                         </div>
                    </div>
                    <img  style="margin-top:30px;" src="@/assets/img/home_xinyun.png" alt="沁恒云、沁恒芯">
              </div>
      </div>
    </div>
    <!-- 我们的优势 -->
    <div class="advantage">
      <div>
        <div style="padding-top:50px">
          <font  class="block-border">
          我 们 的 优 势
          </font>
        </div>
        <div class="advContent">
          <div    @mouseover='boxShow(item,1)' @mouseleave="boxShow(item,2)"  style="overflow:hidden;position:relative;width:300px;border-right:1px solid #dedede;border-bottom:1px solid #dedede;width:299px;height:274px" v-for="(item,index) in advantageData" :key="index">
            <img style="width:121px;height:106px;margin-top:25px;" :src="item.src" :alt='item.alt' />
            <div class="title" style="margin-top:20px;">{{item.word}}</div>
            <div class="content" style="margin-top:10px;">{{item.content}}</div>
                 <div  class='box'  :class="{boxshow:item.boxshow }">
                  <div style="width:80%;margin:50px auto;text-align:left">
                        <div style="border-left:3px solid RGB(255,178,48);width:70%;padding-left:5px">{{item.word}}</div>
                        <div style="font-size:14px;margin-top:10px;" >{{item.detail}}</div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 行业解决方案 -->
    <div class="solution">
      <div>行业解决方案</div>
      <div style="font-size:16px;margin:25px auto 67px;">为各行业连锁门店、大型超市、商业综合体、枢纽商铺提供针对性的解决方案</div>
      <div class="soluContent">
        <div
          v-for="(item,index) in soluData"
          :key="index"
          style="position:relative;text-align: center;width:297x;height:445px;overflow:hidden"
          @mouseover="changeSolu(item)"
          @mouseleave="changeSoluLeave(item)"
        >
          <img style="width:297x;height:445px;" :class="item.num==1?'':'solBigImg'" :src="item.num==1?item.src:item.src2 " :alt='item.alt' />
          <img style="position:absolute;width:143px;top:70px;left:50%;transform:translateX(-50%)" :src="item.icon" alt="">
          <div style="position:absolute;bottom:135px;font-size:30px;width:100%">{{item.title}}</div>
          <div  style="position:absolute;bottom:40px;font-size:16px;width:50%;left:25%; cursor: pointer;"  class="hoverColor">
             {{item.word}} 
             </div>
             <!-- <div  style="position:absolute;bottom:40px;font-size:16px;width:50%;left:25%; cursor: pointer;" @click="goDetail(item,index)" class="hoverColor">
             {{item.word}} 
             </div> -->
        </div>
      </div>
    </div>
    <!-- 合作流程-->
    <div class="servicePro">
       <img style="margin: 104px auto 50px;  " src="@/assets/img/首页-改-2_30.png" alt="">
      <div style="display:flex;width:1180px;overflow:hidden">
        <div v-for="(item,index) in processData" :key="index">
          <div style="position:relative;width:214px;display:flex;align-items:center">
            <img @click="changePro(index)" :src="item.src" :alt='item.alt' />
            <img :src="item.icon" alt />
          </div>
          <div style="width:120px;">{{item.word}}</div>
        </div>
      </div>
      <!-- <el-carousel  arrow="always" class="banner" height='460px' @change='changeBanner'  ref="carousel"  indicator-position='none' >
        <el-carousel-item style="width: 1200px;height: 460px;" v-for="(item,index) in banner" :key="index"  >
          <div style="width:900px;margin:90px auto;display:flex;justify-content: space-between">
              <img  style="width:329px;height:247px;" :src="item.icon" alt="">
              <div >
                  <div>{{item.title}}</div>
                  <div >{{item.content}}</div>
              </div>
          </div>
          <div style="position:absolute;bottom:30px;left:50%;transform:translateX(-50%)">{{item.bottom}}</div>
        </el-carousel-item>
      </el-carousel> -->
    </div>
    <!-- 底部 -->
   <footerPage style="width:100%; margin-top:150px;"></footerPage>
  </div>
</template>
<script>
import Vue from "vue";
import headerPage from "@/components/header.vue"
import footerPage from "@/components/footer.vue"
export default {
  components: {
    headerPage,
    footerPage
  },
  data() {
    return {
      indexBanner:[ {src: require("@/assets/img/产品与服务-改(1)_03.png")}],
      advantageData: [
        { alt: "系统级方案",height:0,boxshow:false, word: "系统级方案", src: require("@/assets/img/index_adv1.png"),content:'沁恒“芯”+沁恒“云”，完整系...',detail:'沁恒“芯”+沁恒“云”，完整系统级数据归集应用方案' },
        { alt: "无感式采集",height:0,boxshow:false, word: "无感式采集", src: require("@/assets/img/index_adv2.png"),content:'纯硬件归集方案，无需安装软...',detail:'纯硬件归集方案，无需安装软件，不影响原有收银流程' },
        { alt: "便捷化部署",height:0,boxshow:false, word: "便捷化部署", src: require("@/assets/img/index_adv3.png") ,content:'平台服务整站打包，一键式私...',detail:'平台服务整站打包，一键式私有云部署'},
        { alt: "高价值转化",height:0,boxshow:false, word: "高价值转化", src: require("@/assets/img/index_adv4.png") ,content:'提供数据归集、图片还原、指令...',detail:'提供数据归集、图片还原、指令过滤、OCR识别、建模提取...丰富的功能定制服务'},
        { alt: "多层级输出",height:0,boxshow:false, word: "多层级输出", src: require("@/assets/img/index_adv5.png") ,content:'根据归集数据的处理深度，分别...',detail:'根据归集数据的处理深度，分别输出指令过滤、票据图片、OCR识别、汇总报表等文件'},
        { alt: "模块化定制",height:0,boxshow:false, word: "模块化定制", src: require("@/assets/img/index_adv6.png") ,content:'提供数据归集、图片还原...',detail:'提供数据归集、图片还原、指令过滤、OCR识别、建模提取...丰富的功能定制服务'},
        { alt: "整流程防护",height:0,boxshow:false, word: "整流程防护", src: require("@/assets/img/index_adv7.png") ,content:'按不同维度对汇集的数据进行...',detail:'按不同维度对汇集的数据进行条件筛选、分类管理，便捷高效'},
        { alt: "集约型管理",height:0,boxshow:false, word: "集约型管理", src: require("@/assets/img/index_adv8.png"),content:'加密通信、宕机保护、离线报警... ',detail:'加密通信、宕机保护、离线报警、远程升级...' }
      ],
      soluData: [
        {icon:require("@/assets/img/index_img1.png"),num:1, src: require("@/assets/img/sol_icon1.png"),src2: require("@/assets/img/sol_icon1(1).png"),alt: "连锁门店" , title: "连锁门店" ,word:"了解详情>>>"},
        {icon:require("@/assets/img/index_img2.png"),num:1,src: require("@/assets/img/sol_icon2.png"), src2: require("@/assets/img/sol_icon2(2).png"),alt: "商业综合体", title: "商业综合体",word:"了解详情>>>" },
        {icon:require("@/assets/img/index_img3.png"),num:1, src: require("@/assets/img/sol_icon3.png"),src2: require("@/assets/img/sol_icon3(3).png"),alt: "大型超市" , title: "大型超市" ,word:"了解详情>>>"},
        {icon:require("@/assets/img/index_img4.png"),num:1, src: require("@/assets/img/sol_icon4.png"),src2: require("@/assets/img/sol_icon4(4).png"),alt: "枢纽商铺" , title: "枢纽商铺" ,word:"了解详情>>>"}
      ],
      processData: [
        {alt: "申请体验",word: "申请体验",src: require("@/assets/img/index_pro1.png"),  icon: require("@/assets/img/process_row_disable.png")},
        {alt: "提出需求",word: "提出需求", src: require("@/assets/img/index_pro2.png"), icon: require("@/assets/img/process_row_disable.png")  },
        {alt: "商务洽谈",word: "商务洽谈", src: require("@/assets/img/index_pro3.png"),icon: require("@/assets/img/process_row_disable.png") },  
        {alt: "签订合同",word: "签订合同",src: require("@/assets/img/index_pro4.png"), icon: require("@/assets/img/process_row_disable.png")},
        {alt: "开发部署",word: "开发部署", src: require("@/assets/img/index_pro5.png"), icon: require("@/assets/img/process_row_disable.png")  }, 
        {alt: "测试验收",word: "测试验收", src: require("@/assets/img/index_pro6.png") }
      ],
      currentPro: 0,
      proImg1: require("@/assets/img/process_row_disable.png"),
      proImg2: require("@/assets/img/process_row_active.png"),
      banner:[ { icon: require("@/assets/img/pro_banner.png"),title:"商务洽谈1",content:'这是是是是是是是是是是是是是是是是是是是是',bottom:'如果您希望了解平台的产品解决方案，点击这里发起合作咨询'},
              { icon: require("@/assets/img/pro_banner.png"),title:"商务洽谈2",content:'这是是是是是是是是是是是是是是是是是是是是',bottom:'如果您希望了解平台的产品解决方案，点击这里发起合作咨询'},
              { icon: require("@/assets/img/pro_banner.png"),title:"商务洽谈3",content:'这是是是是是是是是是是是是是是是是是是是是',bottom:'如果您希望了解平台的产品解决方案，点击这里发起合作咨询'},
              { icon: require("@/assets/img/pro_banner.png"),title:"商务洽谈4",content:'这是是是是是是是是是是是是是是是是是是是是',bottom:'如果您希望了解平台的产品解决方案，点击这里发起合作咨询'},
              { icon: require("@/assets/img/pro_banner.png"),title:"商务洽谈5",content:'这是是是是是是是是是是是是是是是是是是是是',bottom:'如果您希望了解平台的产品解决方案，点击这里发起合作咨询'},
              { icon: require("@/assets/img/pro_banner.png"),title:"商务洽谈6",content:'这是是是是是是是是是是是是是是是是是是是是',bottom:'如果您希望了解平台的产品解决方案，点击这里发起合作咨询'},],
     
    };
  },

  methods: {

       boxShow(item,num){
            if(num==1){
               item.boxshow=true
            }else{
               item.boxshow=false
            }
       },
     changePro(index) {
      // this.$refs.carousel.activeIndex=index
      this.processData.forEach((item, i) => {
        if (i < index) {
          item.icon = this.proImg2;
        } else {
          item.icon = this.proImg1;
        }
      })
    },
    changeSolu(item){
       item.num=2
     },
     changeSoluLeave(item){
         item.num=1
     },
    changeBanner(){
      this.changePro(this.$refs.carousel.activeIndex)
    },
    goDetail(item,index){
         this.$router.push({
           name:"detailPage",
           query:{
             index:index
           }
         }) 
    }
  }
};
</script>
<style scoped  lang='scss'>
.title{
  font-size: 25px;
  color: black
}
.content{
  font-size: 16px;
  color: #999999
}

.headerContent,
.solution,
.advantage {
  width: 100%;
  margin: 0 auto;
}
.headerContent {
  height: 570px;
  background: #f5f5f5;
  margin: 0px auto;
 // border-bottom: 1px solid #dedede
}

.advContent,
.servicePro {
  width: 1200px;
  margin: 0 auto;
}
.sysIntro {
  width: 100%;
  margin: 0 auto;
}
.sys_center{
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  color: #EDFDFF;
  font-size: 30px;
  text-align: left
}
/* 优势 */
.advantage {
  height: 750px;
  background: #f5f5f5;
}

.advContent {
  margin-top: 30px;
  height: 550px;
  background: white;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.box{
 font-size: 30px;
 color: white;
}
/* 解决方案 */
.solution {
  height: 633px;
  background: #3486d1;
  color: white;
  font-size: 30px;
  padding-top: 67px
}
.soluContent {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  height: 448px;
  margin: 0 auto;
}

.block-border{
  font-size:30px;
  font-weight: bold;
  color:#0158a7;
  border-bottom:2px solid #0158a7;
}

@keyframes bigImg{
  to{
    transform: scale(1.5, 1.5)
  }
}
.solBigImg{
     animation: bigImg 1s ease  forwards;
}
/*流程 */
.servicePro {
  background: white;
}
.banner{
  position: relative;
  margin-top: 47px
}

@keyframes bounce-in {
   to{
    transform:translateY(-221px)
  }
}

.boxshow{
   animation: bounce-in .5s ease  forwards;
}

.box{
  background: RGB(38,155,255);
  position: absolute;
  z-index: 2;
  width: 100%;
  height: 276px;
  transform:translateY(60px)
}
.hoverColor{
  color: white;
}
.hoverColor:hover{
 color: rgb(250, 202, 112)
}
</style>
<style  lang='scss'>
.el-carousel__item  {
background: #F5F8FA
}
.headerContent{
  .el-carousel__button{
       background-color: rgb(250, 202, 112)!important
  }
}
</style>


// WEBPACK FOOTER //
// src/view/index.vue